<template>
  <div class="grid grid-cols-2 gap-4">
    <div class="flex flex-col gap-2">
      <label class="text-sm text-gray-700">{{ $t("users.create_user.username") + '*' }} <small v-if="getRangeHints" class="text-gray-500 text-xs">{{ getRangeHints }}</small></label>
      <InputText
        :model-value="uname"
        autocomplete="off"
        class="w-full border text-sm"
        @update:model-value="$emit('update:uname', $event)"
        @blur="touched.uname = true"
      />
      
      <small v-if="touched.uname && validationError" class="text-red-500 text-xs">{{ validationError }}</small>
    </div>
    <div class="flex flex-col gap-2">
      <label class="text-sm text-gray-700">{{ $t("users.create_user.fullname") + '*' }}</label>
      <InputText
        :model-value="fullname"
        autocomplete="off"
        class="w-full border text-sm"
        @update:model-value="$emit('update:fullname', $event)"
        @blur="touched.fullname = true"
      />
      <small v-if="touched.fullname && nameValidationError" class="text-red-500 text-xs">{{ nameValidationError }}</small>
    </div>
    <div class="flex flex-col gap-2">
      <label class="text-sm text-gray-700">{{ $t("users.create_user.email") + '*' }}</label>
      <InputText
        :model-value="email"
        type="email"
        autocomplete="off"
        class="w-full border text-sm"
        @update:model-value="$emit('update:email', $event)"
        @blur="touched.email = true"
      />
      <small v-if="touched.email && emailValidationError" class="text-red-500 text-xs">{{ emailValidationError }}</small>
    </div>
    <div class="flex flex-col gap-2">
      <label class="text-sm text-gray-700">{{ $t("users.create_user.number") }}</label>
      <InputText
        :model-value="phone"
        type="tel"
        placeholder="0XXXXXXXXX"
        autocomplete="off"
        class="w-full border text-sm"
        @update:model-value="$emit('update:phone', $event)"
        @blur="touched.phone = true"
      />
      <small v-if="touched.phone && phoneValidationError" class="text-red-500 text-xs">{{ phoneValidationError }}</small>
    </div>
  </div>
</template>

<script>
import { InputText } from 'primevue';

export default {
  name: 'BasicInfoSection',
  components: {
    InputText,
  },
  props: {
    uname: {
      type: String,
      required: true,
    },
    fullname: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    unameRules: {
      type: Array,
      required: true,
    },
    nameRules: {
      type: Array,
      required: true,
    },
    emailRules: {
      type: Array,
      required: true,
    },
    numberRules: {
      type: Array,
      required: true,
    },
    confirmUnameRules: {
      type: Function,
      required: true,
    },
    confirmUnameRange: {
      type: Function,
      required: true,
    },
    getRangeHints: {
      type: String,
      required: true,
    },
  },
  emits: ['update:uname', 'update:fullname', 'update:email', 'update:phone'],
  data() {
    return {
      touched: {
        uname: false,
        fullname: false,
        email: false,
        phone: false,
      },
    };
  },
  computed: {
    validationError() {
      const rules = this.unameRules.concat(this.confirmUnameRules, this.confirmUnameRange);
      for (const rule of rules) {
        const result = rule(this.uname);
        if (result !== true) return result;
      }
      return null;
    },
    nameValidationError() {
      for (const rule of this.nameRules) {
        const result = rule(this.fullname);
        if (result !== true) return result;
      }
      return null;
    },
    emailValidationError() {
      for (const rule of this.emailRules) {
        const result = rule(this.email);
        if (result !== true) return result;
      }
      return null;
    },
    phoneValidationError() {
      for (const rule of this.numberRules) {
        const result = rule(this.phone);
        if (result !== true) return result;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.username-field :deep(.v-field__details) {
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}

.username-field :deep(.v-messages) {
  max-width: 100%;
  font-size: 0.75rem;
  line-height: 1.2;
}

.username-field :deep(.v-field__details .v-messages) {
  max-width: 100%;
  white-space: normal;
  word-wrap: break-word;
}
</style> 